import React, { useEffect, useRef, useState } from 'react'
import { withTheme } from 'theming'
import VerticalDeckSection from './verticalDeckSection'
import SectionalWithAdSection from './SectionalWithAdSection'

const VerticalStreamSectionalComponent = ({
  componentData,
  modifyData,
  setModalState,
  isEdit = true,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData
  const [playerData, setPlayerData] = useState({})
  const [shouldFocusPlayer, setShouldFocusPlayer] = useState(false)
  const playerContainerRef = useRef(null)

  useEffect(() => {
    if (!shouldFocusPlayer || !playerContainerRef.current) return

    playerContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    playerContainerRef.current.focus({ preventScroll: true })
    setShouldFocusPlayer(false)
  }, [shouldFocusPlayer])

  const handleSectionalPlayerData = (nextPlayerData) => {
    setPlayerData(nextPlayerData)
    setShouldFocusPlayer(true)
  }

  let verticalComponentProps = {
    componentData: { data: data?.vertical_stream_data, id },
    modifyData: modifyData,
    setModalState: setModalState,
    isEdit: isEdit,
    playerData: playerData,
    setPlayerData: setPlayerData,
    playerContainerRef: playerContainerRef,
  }
  let sectionalWithAdProps = {
    componentData: { data: data?.sectional_component_data, id },
    modifyData: modifyData,
    setModalState: setModalState,
    isEdit: isEdit,
    onAdd: onAdd,
    setPlayerData: handleSectionalPlayerData,
  }

  return (
    <div className="w-full">
      <VerticalDeckSection {...verticalComponentProps} />
      <SectionalWithAdSection {...sectionalWithAdProps} />
    </div>
  )
}

export default withTheme(VerticalStreamSectionalComponent)
